export default "__VITE_ASSET__0dfffaed__"